import React, { useEffect, useRef, useState } from "react";
import { Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import axiosInstance from "../../utils/axiosConfig";
import * as CustomToast from "../../components/CustomToastMessage";
import FormManager from "../../components/FormManager";
import SingleError from "../../components/SingleError";

function CouponCodeModal({
  show,
  toggleModelVisibility,
  fetchCoupons,
  data,
  isFullyEditable = true,
  isEndDateOnlyEditable = false,
}) {
  const [formData, setFormData] = useState({
    code: "",
    maxUses: "",
    trialDurationDays: "",
    startDate: "",
    endDate: "",
  });
  const [previewData, setPreviewData] = useState({
    couponCode: "",
    maxUses: "",
    expirationDate: "",
  });
  const formDataRef = useRef({});
  const handleClose = () => {
    toggleModelVisibility("couponCode");
    setFormData("");
    setPreviewData("");
  };

  // Determine field editability
  const getFieldEditable = (field) => {
    if (isFullyEditable) return true;
    if (isEndDateOnlyEditable && field === "endDate") return true;
    return false;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "maxUses" || name === "trialDurationDays") {
      if (/^\d+$/.test(value) || value === "") {
        setFormData({
          ...formData,
          [name]: value,
        });
      }
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }

    if (name === "code") {
      setPreviewData((prev) => ({ ...prev, couponCode: value }));
    }

    if (name === "maxUses") {
      setPreviewData((prev) => ({ ...prev, maxUses: value }));
    }

    if (name === "trialDurationDays") {
      const trialDays = parseInt(value, 10);
      if (!isNaN(trialDays) && trialDays > 0) {
        const expirationDate = new Date();
        expirationDate.setDate(expirationDate.getDate() + trialDays);
        const formattedDate = expirationDate.toLocaleString("en-GB");
        setPreviewData((prev) => ({ ...prev, expirationDate: formattedDate }));
      }
    }
  };

  //   const expireDate = (value) => {
  //     const trialDays = parseInt(value, 10);
  //     if (!isNaN(trialDays) && trialDays > 0) {
  //       const expirationDate = new Date();
  //       expirationDate.setDate(expirationDate.getDate() + trialDays);
  //       const formattedDate = expirationDate.toLocaleString("en-GB");
  //       setPreviewData((prev) => ({ ...prev, expirationDate: formattedDate }));
  //     }
  //   };

  // const handleSubmitForm = async (formData) => {
  //   const formDataToSend = { ...formData };
  //   if (!formData.code) {
  //     formDataToSend.code = undefined;
  //   }

  //   try {
  //     //   const response = await axiosInstance.post(
  //     //     `${process.env.REACT_APP_BACKEND_URL}/api/promo-code`,
  //     //     formDataToSend
  //     //   );
  //     let response;
  //     const { endDate, ...rest } = formDataToSend;
  //     const newData = {
  //       ...rest,
  //       expiresAt: endDate,
  //     };
  //     if (data) {
  //       response = await axiosInstance.put(
  //         `${process.env.REACT_APP_BACKEND_URL}/api/promo-code/${data._id}`,
  //         newData
  //       );
  //     } else {
  //       response = await axiosInstance.post(
  //         `${process.env.REACT_APP_BACKEND_URL}/api/promo-code`,
  //         newData
  //       );
  //     }
  //     CustomToast.success(response.data.message);
  //     if (response) {
  //       fetchCoupons();
  //       handleClose();
  //     }
  //   } catch (error) {
  //     if (error.response.data.status === 400) {
  //       CustomToast.error(error.response?.data?.message);
  //     }
  //     console.error(error.response?.data?.message || "Error sending response");
  //   }
  // };

  // useEffect(() => {
  //   if (data) {
  //     const formatDate = (val) => {
  //       if (!val) return "";
  //       const d = typeof val === "string" ? new Date(val) : val;
  //       if (isNaN(d)) return "";
  //       return d.toISOString().split("T")[0];
  //     };

  //     const defaultFormData = {
  //       code: data?.code ?? "",
  //       maxUses: data?.maxUses ?? "",
  //       trialDurationDays: data?.trialDurationDays ?? "",
  //       startDate: formatDate(data?.startDate),
  //       endDate: formatDate(data?.expiresAt),
  //     };
  //     setFormData(defaultFormData);
  //     formDataRef.current && formDataRef.current.setFormData(defaultFormData);
  //   }
  // }, [data]);

  const handleSubmitForm = async (formData) => {
    const formDataToSend = { ...formData };
    if (!formData.code) {
      formDataToSend.code = undefined;
    }

    // Convert date-time to UTC ISO string
    if (formDataToSend.startDate) {
      formDataToSend.startDate = new Date(
        formDataToSend.startDate
      ).toISOString();
    }
    if (formDataToSend.endDate) {
      formDataToSend.endDate = new Date(formDataToSend.endDate).toISOString();
    }

    try {
      let response;
      const { endDate, ...rest } = formDataToSend;
      const newData = {
        ...rest,
        expiresAt: endDate,
      };
      if (data) {
        response = await axiosInstance.put(
          `${process.env.REACT_APP_BACKEND_URL}/api/promo-code/${data._id}`,
          newData
        );
      } else {
        response = await axiosInstance.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/promo-code`,
          newData
        );
      }
      CustomToast.success(response.data.message);
      if (response) {
        fetchCoupons();
        handleClose();
      }
    } catch (error) {
      if (error.response.data.status === 400) {
        CustomToast.error(error.response?.data?.message);
      }
      console.error(error.response?.data?.message || "Error sending response");
    }
  };
  // ...existing code...

  useEffect(() => {
    if (data) {
      // Converts UTC string to local datetime-local format
      const formatDateTimeLocal = (val) => {
        if (!val) return "";
        const d = typeof val === "string" ? new Date(val) : val;
        if (isNaN(d)) return "";
        // Get local date and time in YYYY-MM-DDTHH:mm format
        const pad = (n) => n.toString().padStart(2, "0");
        const yyyy = d.getFullYear();
        const mm = pad(d.getMonth() + 1);
        const dd = pad(d.getDate());
        const hh = pad(d.getHours());
        const min = pad(d.getMinutes());
        return `${yyyy}-${mm}-${dd}T${hh}:${min}`;
      };

      const defaultFormData = {
        code: data?.code ?? "",
        maxUses: data?.maxUses ?? "",
        trialDurationDays: data?.trialDurationDays ?? "",
        startDate: formatDateTimeLocal(data?.startDate),
        endDate: formatDateTimeLocal(data?.expiresAt),
      };
      setFormData(defaultFormData);
      formDataRef.current && formDataRef.current.setFormData(defaultFormData);
    }
  }, [data]);

  return (
    <>
      <Modal
        show={show}
        className="custom-modal create-new-access"
        size="lg"
        centered
        scrollable
        onHide={handleClose}
      >
        <Modal.Header closeButton>
          <div>
            <Modal.Title>{`${
              data ? "Edit" : "Create New"
            } Coupon Code`}</Modal.Title>
            <p>
              {`${
                data ? "Edit the" : "Generate a new"
              } coupon code for users to get free access to your
              application.`}
            </p>
          </div>
        </Modal.Header>
        <Modal.Body>
          <FormManager
            initialValues={formData}
            validationRules={{
              code: [{ required: true, message: "Coupon code is required." }],
              maxUses: [
                { required: true, message: "Maximum uses is required." },
              ],
              trialDurationDays: [
                { required: true, message: "Trial duration days is required." },
              ],
              startDate: [
                { required: true, message: "Start date is required." },
              ],
              endDate: [{ required: true, message: "End date is required." }],
            }}
            onSubmit={handleSubmitForm}
            isNotTimedValue="description"
            onSetFormData={(setter) => {
              formDataRef.current = setter;
            }}
          >
            {({
              formData,
              isEditable,
              errors,
              handleChange,
              handleSubmit,
              validateField,
              isSubmitting,
            }) => (
              <form onSubmit={handleSubmit}>
                <div className="row g-3">
                  <div className="col-12">
                    <Form.Group controlId="code">
                      <Form.Label>Coupon Code</Form.Label>
                      <Form.Control
                        type="text"
                        name="code"
                        value={formData.code}
                        onChange={(e) => {
                          handleChange(e, "code");
                        }}
                        placeholder="Enter coupon code"
                        disabled={!getFieldEditable("code")}
                      />
                    </Form.Group>
                    {errors?.code && <SingleError error={errors?.code} />}
                  </div>
                  <div className="col-12">
                    <hr />
                  </div>
                  <div className="col-xl-6">
                    <Form.Group controlId="maxUses">
                      <Form.Label>Maximum Users</Form.Label>
                      <Form.Control
                        type="text"
                        name="maxUses"
                        value={formData.maxUses}
                        onChange={(e) => {
                          handleChange(e, "maxUses");
                        }}
                        placeholder="Enter maximum users"
                        disabled={!getFieldEditable("maxUses")}
                      />
                    </Form.Group>
                    {errors?.maxUses && <SingleError error={errors?.maxUses} />}
                  </div>
                  <div className="col-xl-6">
                    <Form.Group controlId="trialDurationDays">
                      <Form.Label>Subscription Duration Days</Form.Label>
                      <Form.Control
                        type="text"
                        name="trialDurationDays"
                        value={formData.trialDurationDays}
                        onChange={(e) => {
                          handleChange(e, "trialDurationDays");
                        }}
                        placeholder="Enter subscription duration days"
                        disabled={!getFieldEditable("trialDurationDays")}
                      />
                    </Form.Group>
                    {errors?.trialDurationDays && (
                      <SingleError error={errors?.trialDurationDays} />
                    )}
                  </div>
                  <div className="col-xl-6">
                    <Form.Group controlId="startDate">
                      <Form.Label>Coupon Start Date & Time</Form.Label>
                      <Form.Control
                        type="datetime-local"
                        value={formData.startDate}
                        min={new Date(Date.now()).toISOString().slice(0, 16)}
                        onChange={(e) => {
                          const endDateData = {
                            target: { value: "" },
                          };
                          handleChange(endDateData, "endDate");
                          handleChange(e, "startDate");
                        }}
                        onClick={(e) => e.target.showPicker()}
                        pattern="\d{4}-\d{2}-\d{2}T\d{2}:\d{2}"
                        disabled={!getFieldEditable("startDate")}
                      />
                    </Form.Group>
                    {errors?.startDate && (
                      <SingleError error={errors?.startDate} />
                    )}
                  </div>
                  <div className="col-xl-6">
                    <Form.Group controlId="endDate">
                      <Form.Label>Coupon Expire Date & Time</Form.Label>
                      <Form.Control
                        type="datetime-local"
                        value={formData?.endDate}
                        min={
                          formData?.startDate
                            ? formData?.startDate
                            : new Date(Date.now()).toISOString().slice(0, 16)
                        }
                        onChange={(e) => {
                          handleChange(e, "endDate");
                        }}
                        onClick={(e) => e.target.showPicker()}
                        pattern="\d{4}-\d{2}-\d{2}T\d{2}:\d{2}"
                        disabled={!getFieldEditable("endDate")}
                      />
                    </Form.Group>
                    {errors?.endDate && <SingleError error={errors?.endDate} />}
                  </div>
                  {/* <div className="col-xl-6">
                    <Form.Group controlId="startDate">
                      <Form.Label>Coupon Start Date</Form.Label>
                      <Form.Control
                        type="date"
                        value={formData.startDate}
                        min={new Date(Date.now()).toISOString().split("T")[0]}
                        onChange={(e) => {
                          const endDateData = {
                            target: { value: "" },
                          };
                          handleChange(endDateData, "endDate");
                          handleChange(e, "startDate");
                        }}
                        onClick={(e) => e.target.showPicker()}
                        pattern="\d{4}-\d{2}-\d{2}"
                        disabled={!getFieldEditable("startDate")}
                      />
                    </Form.Group>
                    {errors?.startDate && (
                      <SingleError error={errors?.startDate} />
                    )}
                  </div>
                  <div className="col-xl-6">
                    <Form.Group controlId="endDate">
                      <Form.Label>Coupon Expire Date</Form.Label>
                      <Form.Control
                        type="date"
                        value={formData?.endDate}
                        min={
                          new Date(formData?.startDate || Date.now())
                            .toISOString()
                            .split("T")[0]
                        }
                        onChange={(e) => {
                          handleChange(e, "endDate");
                        }}
                        onClick={(e) => e.target.showPicker()}
                        pattern="\d{4}-\d{2}-\d{2}"
                        disabled={!getFieldEditable("endDate")}
                      />
                    </Form.Group>
                    {errors?.endDate && <SingleError error={errors?.endDate} />}
                  </div> */}
                </div>
                {/* <div className="coupon-code-card">
                  <p>Preview:</p>
                  <div className="d-flex align-items-center gap-3">
                    <span>{previewData?.couponCode}</span>
                    <button className="active-btn">Active</button>
                  </div>
                  <h6>
                    {previewData?.maxUses} uses | Expires{" "}
                    {previewData?.expirationDate}
                  </h6>
                </div> */}
                <div className="d-flex justify-content-center gap-3 mt-4">
                  <button
                    className="btn-outline edit-hover fs-16 px-3 fw-700"
                    onClick={handleClose}
                    type="button"
                  >
                    Cancel
                  </button>
                  <button
                    className="btn-primary fs-16 fw-600 px-5"
                    type="submit"
                    disabled={!isFullyEditable && !isEndDateOnlyEditable}
                  >
                    {data ? "Update Coupon Code" : "Create Coupon Code"}
                  </button>
                </div>
              </form>
            )}
          </FormManager>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default CouponCodeModal;
